import * as React from "react";
import { getAllCampaigns } from "../../redux/actions/ShowAllCampaign";
import { useDispatch, useSelector } from "react-redux";
import DataTable from "react-data-table-component";
import "./ViewData.css";
import DeleteIcon from "@mui/icons-material/Delete";
import Button from "@mui/material/Button";
import { Paper, Toolbar } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
  deleteAll,
  getParticularforupdate,
} from "../../redux/actions/addCampaigndata";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import SentimentVeryDissatisfiedIcon from "@mui/icons-material/SentimentVeryDissatisfied";
import EmojiEmotionsIcon from "@mui/icons-material/EmojiEmotions";
import EditIcon from "@mui/icons-material/Edit";
import Popups from "../../components/Comman/popups/Popups";
import Update from "./update.json";
import DeleteJson from "./delete.json";
import { Container } from "react-bootstrap";
import CardWithButton from "../../components/Comman/button-new";

const sortIcon = <ArrowDownwardIcon />;

const ViewData = () => {
  const [openDeleteDialog, setOpenDeleteDialog] = React.useState(false);
  const [openUpdateDialog, setOpenUpdateDialog] = React.useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const [searchQuery, setSearchQuery] = React.useState(null);
  const [uitype, setUiType] = React.useState("");
  const [showCampaign, setShowCampaign] = React.useState("");
  let [idParams, setIdParams] = React.useState("");
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowPerPage] = React.useState(5);
  const [filtered, setFiltered] = React.useState({});
  const [total, setTotal] = React.useState(0);
  const [deleteButton, setDeleteButton] = React.useState(false);
  const [updateTable, setUpdateTable] = React.useState(false);
  const [debouncedSearchQuery, setDebouncedSearchQuery] =
    React.useState(searchQuery);

  const dispatch = useDispatch();
  const selector = useSelector((state) => state.addCampaignReducer);
  const data = selector.data;

  const navigate = useNavigate();

  const handleClickOpen = () => {
    setOpenUpdateDialog(true);
  };

  const handleClose = () => {
    setOpenDeleteDialog(false);
    setOpenUpdateDialog(false);
    setSearchParams("");
  };

  React.useEffect(() => {
    localStorage.removeItem("uiType");
    localStorage.removeItem("campaign_name");
    localStorage.removeItem("campaignId");
    localStorage.removeItem("updateID");
    localStorage.removeItem("campaign_type");
    localStorage.removeItem("key");
  }, []);

  React.useEffect(() => {
    dispatch(
      getAllCampaigns({
        page: page,
        limit: rowsPerPage,
        search: debouncedSearchQuery?.toLowerCase() || "",
      })
    ).then((res) => {
      setTotal(res?.total);
    });
    setSearchParams("");
  }, [page, rowsPerPage, debouncedSearchQuery, dispatch, setSearchParams]);

  const handleUpdateOpen = (id, uitype, datas) => {
    setDeleteButton(false);
    setShowCampaign(datas);
    setUiType(uitype);
    const filteredData = data.filter((item) => item?.campaign_Id === id);
    setFiltered(filteredData);
    const filteredUiTypes = filteredData.map((item) => item?.ui_type);
    let querySetter = `?campaign_Id=${id}&ui_type=${filteredUiTypes}`;
    if (filteredUiTypes.includes("external")) {
      const queryString = querySetter;
      setIdParams(id);
      setSearchParams(queryString);
      handleClickOpen();
    } else if (filteredUiTypes.includes("plutoshome")) {
      const queryString = querySetter;
      setIdParams(id);
      setSearchParams(queryString);
      handleClickOpen();
    }
  };

  const handleDelete = (id, data) => {
    setDeleteButton(true);
    setShowCampaign(data?.campaign_name);
    setIdParams(id);
    setOpenDeleteDialog(true);
  };

  const confirmDelete = () => {
    let token = localStorage.getItem("token");
    dispatch(deleteAll(idParams, token)).then((res) => {
      setOpenDeleteDialog(false);
      setUpdateTable(true);
    });
  };

  const columns = [
    {
      name: "Campaign Id",
      selector: (row) => row?.campaign_Id,
      sortable: true,
    },
    {
      name: "Campaign Name",
      selector: (row) => row?.campaign_name || "null",
      sortable: true,
    },
    {
      name: "Campaign Type",
      selector: (row) => row?.campaign_type,
      sortable: true,
    },
    {
      name: "SEO Data",
      selector: (row) =>
        row?.seoDone ? (
          <EmojiEmotionsIcon className="text-success ms-3" />
        ) : (
          <SentimentVeryDissatisfiedIcon className="text-danger ms-3" />
        ),
      sortable: true,
    },
    {
      name: "Updated At",
      selector: (row) => (row?.updated_at ? row?.updated_at?.slice(0, 10) : ""),
      sortable: true,
    },

    {
      name: <span className="ms-4">Action</span>,
      selector: (row) => (
        <div className="d-flex">
          <div style={{ cursor: "pointer" }}>
            <EditIcon
              className="text-success ms-2"
              onClick={() =>
                handleUpdateOpen(
                  row?.campaign_Id,
                  row?.ui_type,
                  row?.campaign_name
                )
              }
            />
          </div>
          <div className="" style={{ cursor: "pointer" }}>
            <DeleteIcon
              className="text-danger ms-3 fs-5"
              onClick={() => handleDelete(row?.campaign_Id, row)}
            />
          </div>
        </div>
      ),
      style: {
        position: "sticky",
        right: "0",
        backgroundColor: "#fff",
      },
    },
  ];

  const conditionalRowStyles = [
    {
      when: (row) => !row?.seoDone,
      style: {
        backgroundColor: "#ffe6e6",
      },
    },
  ];

  const handleCreateCampaign = () => {
    navigate("/add-campaignData");
  };

  const handleUpdate = (value) => {
    let name;
    if (value === "header") {
      name = value;
    } else if (value === "body" && uitype === "external") {
      name = value;
    } else if (value === "body" && uitype === "plutoshome") {
      name = value;
    } else if (value === "footer") {
      name = value;
    }
    dispatch(getParticularforupdate({ id: idParams, name: name })).then(
      (res) => {
        if (!res) {
          const id = filtered?.[0]?.campaign_Id;
          localStorage.setItem("updateID", id);
          localStorage.setItem("campaign_name", filtered?.[0]?.campaign_name);
          return handleCreateCampaign();
        } else if (res.success === true || res.success === false) {
          let route = "/";
          if (name === "header") {
            route = `/header-page/${searchParams}&${name}`;
          } else if (name === "body" && uitype === "external") {
            route = `/external-body-update/${searchParams}&${name}`;
            localStorage.setItem("campaign_name", filtered?.[0]?.campaign_name);
          } else if (name === "body" && uitype === "plutoshome") {
            route = `/plutoshome-body-update/${searchParams}&${name}`;
            localStorage.setItem("campaign_name", filtered?.[0]?.campaign_name);
          } else if (name === "footer") {
            route = `/footer-update/${searchParams}&${name}`;
            localStorage.setItem("campaign_name", filtered?.[0]?.campaign_name);
          }
          navigate(route);
        }
      }
    );
  };

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
  };

  // Debouncing logic
  React.useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchQuery(searchQuery);
    }, 1000); // Adjust the delay as needed

    // Cleanup function to clear the timeout when searchQuery changes
    return () => clearTimeout(handler);
  }, [searchQuery]);

  React.useEffect(() => {
    if (updateTable) {
      dispatch(
        getAllCampaigns({
          page,
          limit: rowsPerPage,
          search: debouncedSearchQuery || null,
        })
      );
      setUpdateTable(false);
    }
  }, [debouncedSearchQuery, dispatch, page, rowsPerPage, updateTable, data]);

  const handleAction = (id) => {
    if (id === "cancel") {
      handleClose();
    } else if (id === "confirm") {
      confirmDelete();
    }
  };

  const titleContent = (
    <>
      <div className="text-bg-danger p-2 m-3 mb-2 mt-1 text-center rounded-1">
        Confirm Delete
        <div className="text-warning">Campaign Name: {showCampaign}</div>
      </div>
      <div className="text-secondary p-1 text-center rounded-1">
        Are you sure ! you want to delete this Campaign?
      </div>
    </>
  );

  const titleUpdate = (
    <>
      <div className="text-bg-secondary p-2 m-3 mb-2 mt-1 text-center rounded-1">
        What Do You Want To Update ?
        <div className="text-warning">Campaign Name : {showCampaign}</div>
      </div>
    </>
  );

  return (
    <Container style={{
      border: "1px solid rgba(0, 0, 0, 0.1)",
      padding: "20px 0px 20px 20px",
      width: "98%",
      marginBottom: "5%"
    }}
      className="shadow-md bg-white rounded ">
      <div>
        <CardWithButton
          title="Add Campaigns Data"
          className=""
          buttonLabel="Create Campaigns"
          buttonIcon={<AddIcon />}
          buttonClick={handleCreateCampaign}
        />
      </div>
      <div className="mt-4">
        <Paper elevation={3} className="p-4">
          <>
            <DataTable
              columns={columns}
              data={data}
              defaultSortFieldId={1}
              className="mt-0"
              pagination
              paginationTotalRows={total}
              paginationRowsPerPageOptions={[5, 10, 20, 50, 100]}
              paginationComponentOptions={{
                rowsPerPageText: "Records per page:",
                rangeSeparatorText: "out of",
              }}
              fixedHeader
              fixedHeaderScrollHeight="400px"
              paginationPerPage={rowsPerPage}
              paginationServer={true}
              onChangePage={(page) => setPage(page - 1)}
              onChangeRowsPerPage={(currentRowsPerPage) => {
                setRowPerPage(currentRowsPerPage);
              }}
              sortIcon={sortIcon}
              highlightOnHover
              subHeader
              subHeaderComponent={
                <input
                  type="text"
                  placeholder="Search Campaign name and Campaign ID..."
                  className="w-50 form-control"
                  value={searchQuery || ""}
                  onChange={handleSearch}
                />
              }
              conditionalRowStyles={conditionalRowStyles}
            />
          </>
        </Paper>
      </div>
      <React.Fragment>
        <Popups
          open={openUpdateDialog}
          onClose={handleClose}
          onAction={handleUpdate}
          actions={Update}
          title={titleUpdate}
          deleteButton={deleteButton}
        />
      </React.Fragment>
      <Popups
        open={openDeleteDialog}
        onClose={handleClose}
        onAction={handleAction}
        actions={DeleteJson}
        title={titleContent}
        deleteButton={deleteButton}
      />
    </Container>
  );
};
export default ViewData;
